import { Formik } from "formik";

import { Checkbox, FormLabel, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { MarketingSummaryAnalyticsService } from "@analytics/index";

import { useRateChatMessage } from "@queries/chat.query";

import { PopupActions } from "@store/popupStore";

import theme from "@theme/index";

const answerOptions = [
  { label: "Inaccuracy or Misinterpretation of Information", value: "1" },
  { label: "Lack of Specificity or Over-Generalization", value: "2" },
  { label: "Omission of Key Details", value: "3" },
  { label: "Failure to Capture the Intended Audience", value: "4" },
  { label: "Difficult to Use", value: "5" },
];

interface IFormValues {
  feedback: string;
  issues: string[];
}

interface IRateSummaryProperties {
  message: string;
  messageId: string;
  promptType: string;
  summaryId: string;
  technologyId: string;
}

const RateSummary = ({ message, messageId, promptType, summaryId, technologyId }: IRateSummaryProperties) => {
  const { mutateAsync: rateChatMessage } = useRateChatMessage();

  return (
    <Box sx={{ width: "800px" }}>
      <Typography fontWeight={600} variant="body1">
        What is the issue with this response? Select all that apply.
      </Typography>
      <Formik
        initialValues={
          {
            feedback: "",
            issues: [],
          } as IFormValues
        }
        onSubmit={(values) => {
          void rateChatMessage({
            issues: values.issues,
            message,
            messageId,
            promptType,
            rating: "negative",
            summaryId,
            technologyId,
            userFeedback: values.feedback,
          });
          PopupActions.closeModal();
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 2 }}>
            {answerOptions.map((option) => (
              <Box key={option.value} sx={{ alignItems: "center", display: "flex" }}>
                <Checkbox
                  id={option.value}
                  onChange={() =>
                    setFieldValue(
                      "issues",
                      values.issues.includes(option.label)
                        ? values.issues.filter((issue) => issue !== option.label)
                        : [...values.issues, option.label],
                    )
                  }
                />
                <FormLabel htmlFor={option.value} sx={{ color: theme.palette.text.primary, cursor: "pointer" }}>
                  {option.label}
                </FormLabel>
              </Box>
            ))}

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2 }}>
              <Typography fontWeight={600} variant="body1">
                Additional Feedback
              </Typography>
              <TextField
                multiline
                name="feedback"
                onChange={(event) => setFieldValue("feedback", event.target.value)}
                placeholder="Enter feedback here..."
                rows={3}
                sx={{ width: "100%" }}
                value={values.feedback}
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
              <Button
                color="primary"
                disabled={values.issues.length === 0 && values.feedback.trim() === ""}
                onClick={() => handleSubmit()}
                sx={{ borderRadius: "8px" }}
                variant="contained"
              >
                Submit
              </Button>
            </Box>
          </Box>
        )}
      </Formik>
    </Box>
  );
};

export default RateSummary;
